import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'

const getPrivateLibraries = state => state.user.extra ? state.user.extra.libraries : []

const library_name_selector = libraryId => createSelector(
	[getPrivateLibraries],
	privateLibraries => {
		const library = privateLibraries.find(library => library.id === libraryId)
		let libraryName
		let libraryType
		if (library) {
			switch (library.library_type) {
				case viewTypes.SCHOOL_LIBRARY:
					libraryType = 'School Library'
					break
				case viewTypes.DISTRICT_LIBRARY:
					libraryType = 'District Library'
					break
				case viewTypes.CONTENT_PACKAGES:
					libraryType = 'Supplemental Curricula'
					libraryName = library.title
					break
			}
		}
		return {
			libraryName,
			libraryType,
		}
	}
)
export default library_name_selector
